export var getDemoItem = function getDemoItem(target) {
  var parent = target;
  while (parent) {
    var classList = parent.classList;
    if (Array.prototype.slice.call(classList).indexOf('demo-item') > -1) {
      var profile = parent === null || parent === void 0 ? void 0 : parent.getAttribute('data-profile');
      return profile && JSON.parse(profile) ? parent : null;
    }
    parent = parent.parentElement;
    if (!parent || parent === document.body) {
      return null;
    }
  }
};
export var contains = function contains(root, ele) {
  var node = ele;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};
export var copyText = function copyText(text) {
  var input = document.createElement('input');
  var currentFocus = document.activeElement;
  document.body.appendChild(input);
  input.value = text;
  input.focus();
  if (input.setSelectionRange) {
    input.setSelectionRange(0, input.value.length);
  } else {
    input.select();
  }
  var flag = false;
  try {
    flag = document.execCommand('copy');
  } catch (e) {}
  document.body.removeChild(input);
  currentFocus.focus();
  return flag;
};